import type { IconName } from "../../ui/assets/icons";

export const tagManifest = {
  featured: { icon: "sparkles", label: "Featured" },
  ai: { icon: "brain", label: "AI" },
  engineering: { icon: "code", label: "Engineering" },
  security: { icon: "shield-check", label: "Security" },
  identity: { icon: "fingerprint-pattern", label: "Identity" },
  observability: { icon: "activity", label: "Observability" },
  productivity: { icon: "building-2", label: "Productivity" },
  data: { icon: "database", label: "Data" },
  communication: { icon: "message-circle", label: "Communication" },
  documents: { icon: "file-scan", label: "Documents" },
  it: { icon: "headset", label: "IT" },
  custom: { icon: "cog", label: "Custom" },
} as const satisfies Record<string, { icon: IconName; label: string }>;

export type AppTag = keyof typeof tagManifest;
